var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChukotkaTagsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41268 0.77533L14.02 0.93387C15.0108 0.961884 15.8303 1.71403 15.943 2.69879C16.1924 4.87864 16.1924 7.07982 15.943 9.25967C15.8303 10.2444 15.0108 10.9966 14.02 11.0246L9.76179 11.145V12.7247H12.2673C12.5866 12.7247 12.8454 12.9836 12.8454 13.3029C12.8454 13.6222 12.5866 13.8811 12.2673 13.8811H4.55812C4.23879 13.8811 3.97993 13.6222 3.97993 13.3029C3.97993 12.9836 4.23879 12.7247 4.55812 12.7247H7.06359V11.145L2.80533 11.0246C1.81454 10.9966 0.995044 10.2444 0.88237 9.25967C0.63296 7.07982 0.63296 4.87864 0.88237 2.69879C0.995044 1.71403 1.81454 0.961884 2.80533 0.933871L8.41268 0.77533ZM8.41268 1.93216L2.83802 2.08978C2.42233 2.10153 2.07852 2.41709 2.03125 2.83024C1.79183 4.92274 1.79183 7.03572 2.03125 9.12822C2.07852 9.54137 2.42233 9.85693 2.83801 9.86868L8.41268 10.0263L13.9873 9.86868C14.403 9.85693 14.7468 9.54137 14.7941 9.12822C15.0335 7.03572 15.0335 4.92274 14.7941 2.83025C14.7468 2.41709 14.403 2.10153 13.9873 2.08978L8.41268 1.93216Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChukotkaTagsIcon);
export default __webpack_public_path__ + "static/media/chukotka-tags-icon.fc95dce466b0cc0035a82946d3294cce.svg";
export { ForwardRef as ReactComponent };